import { Injectable } from '@angular/core';
import { dispatch } from '@angular-redux/store';
import { ServiceDeploymentFilterActions } from '../actions/servicedeployment.constants';

@Injectable()
export class ServicedeploymentReduxService {
  constructor() {}

  public setFilter(filter: object) {
    this._setFilter(filter);
  }

  @dispatch()
  private _setFilter = (filter: object) => ({
    type: ServiceDeploymentFilterActions.SetFilter,
    payload: filter,
  });
}
